import {createContext, type ReactNode, useContext} from "react";

import {getCurrentIdToken} from "../firebase/firebaseClient";
import type {TypesenseIdTokenGetter} from "../typesenseAuth";

const TypesenseIdTokenContext = createContext<TypesenseIdTokenGetter>(getCurrentIdToken);

export function TypesenseIdTokenProvider({
    children,
    getIdToken,
}: {
    children: ReactNode;
    getIdToken: TypesenseIdTokenGetter;
}) {
    return <TypesenseIdTokenContext.Provider value={getIdToken}>{children}</TypesenseIdTokenContext.Provider>;
}

export function useTypesenseIdToken(): TypesenseIdTokenGetter {
    return useContext(TypesenseIdTokenContext);
}
